import graphql__8803b7adc88d2faa7f3d from "./__generated__/SignInMutation.graphql.js";import { commitMutation } from "react-relay";
import { graphql } from "react-relay";
import mapValues from "lodash/mapValues";
import appRelayEnvironment from "../config/AppRelayEnvironment";

const mutation = graphql__8803b7adc88d2faa7f3d;

function signIn(form, onCompleted) {
  const variables = mapValues(form.fields, field => field.value || field.checked);

  return commitMutation(appRelayEnvironment, {
    mutation,
    variables,
    onCompleted,
    onError: error => console.error(error)
  });
}

export { signIn };
